import {
  RECEIVE_PAYMENT_RESPONSE,
  RECEIVE_PAYMENT_COMPLETE,
  RECEIVE_FEE,
  RECEIVE_ERROR,
} from '../../actions/stripe';

export const initialState = {
  service: '',
  narvarPaymentId: '',
  paymentIntentSecret: '',
  publishableKey: '',
  completedPayment: false,
  fee: '',
};

export default (
  state = initialState,
  {
    type,
    data: {
      service,
      narvarPaymentId,
      paymentIntentSecret,
      publishableKey,
      completedPayment,
      fee,
      transactionDescription,
      errorMessage,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_PAYMENT_RESPONSE:
      return {
        ...state,
        service,
        narvarPaymentId,
        paymentIntentSecret,
        publishableKey,
        transactionDescription,
      };
    case RECEIVE_PAYMENT_COMPLETE:
      return {
        ...state,
        completedPayment,
      };
    case RECEIVE_FEE:
      return {
        ...state,
        fee,
      };
    case RECEIVE_ERROR:
      return {
        ...state,
        errorMessage,
      };
    default:
      return state;
  }
};
